export default "__VITE_ASSET__BzZNzJ40__"